module.exports = __webpack_public_path__ + "img/detail-nav.f6406683.svg";